import template        from 'scripts/defa/control/accessories-holder/accsessoryAddNewView.jst.html';
import View            from 'scripts/poppet/view';
import { Vue }         from 'vue/defavue';


/**
 * defa.views.AddNewAccessory
 * A flow for adding a new accessory under one unit
 * @version 1.2.1
 */

const AddNewAccessory = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: 'card',
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	onDomRefresh() {
		let self   = this;
		
		let addAccessoryVue = new Vue ({
			el: '#add-accessorie-vue-container',
			data() {
				return {
					inputValue: '',
					submitError: ''
				}
			},
			methods: {
				save() {
					let serial = this.inputValue.trim().replace( /-|\s/g, '' );
					if ( !serial ) {
						return;
					}
					self.trigger(
						'add:accessory',
						serial,
						{
							success: function () {
								console.log('Accessorie added!')
							},
							error: function (error) {
								addAccessoryVue.submitError = error
							}
						}
					);
				},
				onClickClose(){
					self.trigger('accessory:close', self.model);
				}
			},
			computed: {
				disableFormSubmit: function() {
					return !this.inputValue
				}
			}
			
		});
	},
	
} );

export default AddNewAccessory;
